import { Rate } from 'antd'

import _map from 'lodash/map'
import _size from 'lodash/size'

import Image from 'components/Image'
import Title from 'components/Title'
import Paragraph from 'components/Paragraph'
import Icon from 'components/Icon'

import numeral from 'utils/numeral'
import asyncComponent from 'utils/asyncComponent'

import { useMobileDetect } from 'hooks/mobileDetect'

import theme from 'style/theme'

import Styled from './styled'

const Carousel = asyncComponent(() => import('components/Carousel'))

const CardItem = ({ score, name, description, image }) => {
  return (
    <div className="review-item">
      <div className="info-block">
        <Title className="title font-semibold" level={4} ellipsis={{ rows: 1 }}>
          {name}
        </Title>

        <div className="score-block">
          <div className="score">
            <div className="text-score">
              <Paragraph>{numeral(score).format('0.0')}</Paragraph>
            </div>
          </div>
          <div className="rate">
            <Rate disabled allowHalf defaultValue={score} />
          </div>
        </div>

        <Paragraph className="detail" ellipsis={{ rows: 3 }}>
          {description}
        </Paragraph>

        <div className="image-container">
          <div className="image-review">
            {image?.[0]?.url && <Image src={image?.[0]?.url} alt={image?.[0]?.alternativeText} />}
          </div>

          <div className="image-review">
            {image?.[1]?.url && <Image src={image?.[1]?.url} alt={image?.[1]?.alternativeText} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default function SectionReview({ data }) {
  const { isMobile } = useMobileDetect()

  const title = data?.title
  const contents = data?.reviewContent

  return (
    <Styled>
      <div className="header-container">
        <div className="text-header">
          <Paragraph className="font-semibold">{title}</Paragraph>
        </div>
      </div>

      <div className="content">
        <div className="review-content">
          {isMobile ? (
            <div className="mobile">
              {_map(contents, (item, index) => {
                const score = item?.score
                const name = item?.name
                const description = item?.description
                const image = item?.image

                return (
                  <CardItem
                    key={index}
                    score={score}
                    name={name}
                    description={description}
                    image={image}
                  />
                )
              })}
            </div>
          ) : (
            <div className="desktop">
              <Carousel
                options={{
                  spaceBetween: 40,
                  slidesPerView: 1,
                  pagination: false,
                  navigation: {
                    nextEl: '.swiper-button-custom-next',
                    prevEl: '.swiper-button-custom-prev',
                  },
                  breakpoints: {
                    992: {
                      slidesPerView: 3,
                      pagination: false,
                    },
                    768: {
                      slidesPerView: 1,
                      pagination: false,
                    },
                  },
                }}
                items={contents}
                uiRenderer={(item, index) => {
                  const score = item?.score
                  const name = item?.name
                  const description = item?.description
                  const image = item?.image

                  return (
                    <CardItem
                      key={index}
                      score={score}
                      name={name}
                      description={description}
                      image={image}
                    />
                  )
                }}
              />

              {_size(contents) > 3 && (
                <>
                  <div className="swiper-button-custom swiper-button-custom-next">
                    <Icon.ChevronRight style={{ fontSize: 40, color: theme.black }} />
                  </div>
                  <div className="swiper-button-custom swiper-button-custom-prev">
                    <Icon.ChevronLeft style={{ fontSize: 40, color: theme.black }} />
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </Styled>
  )
}
